import { render, staticRenderFns } from "./Payments.yaml?vue&type=template&id=1184b945&component"
import script from "./Payments.yaml?vue&type=script&lang=ts&component"
export * from "./Payments.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports